import { useDispatch } from "react-redux";
import "./ProfileUnderReview.css";
import { resetStore } from "../../../config/action";
import { startTransition } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export interface ProfileUnderReviewModalProps {
  show?: boolean;
  onHide?: () => void;
}

const ProfileUnderReview = ({
  show,
  onHide,
}: ProfileUnderReviewModalProps = {}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleGotIt = () => {
    startTransition(() => {
      dispatch(resetStore());
      localStorage.clear();
      navigate("/investor/login");
    });
  };

  const goToMyProfile = () => {
    localStorage.setItem("Tab_Selected", "");
    if (onHide) onHide();
    navigate("/investor/my-profile");
  };

  const content = (
    <div className="pur-card">
      {onHide && (
        <button
          type="button"
          className="btn-close pur-modal-close"
          aria-label="Close"
          onClick={onHide}
        />
      )}
      <div className="pur-icon">⏱</div>

      <h2 className="pur-title">Profile Under Review</h2>

      <p className="pur-subtitle">
        Your profile has been submitted successfully and is currently under
        verification by our team.
      </p>

      <div className="pur-reason-box">
        <span className="pur-label">Review Status</span>
        <p>
          Verification is in progress. This process usually takes{" "}
          <b>24–48 hours</b>.
        </p>
      </div>

      <p className="pur-note">
        We’ll notify you once the review is completed. You can also check your
        profile status anytime from your dashboard.
      </p>

      <div className="d-flex flex-wrap gap-3 justify-content-center mt-4">
        <Button className="pur-btn" onClick={goToMyProfile}>
          Go to My Profile
        </Button>

        {onHide ? (
          <Button className="pur-btn-outline" onClick={onHide}>
            Got It
          </Button>
        ) : null}
      </div>
    </div>
  );

  if (show !== undefined) {
    return (
      <Modal
        show={show}
        onHide={onHide}
        centered
        dialogClassName="pur-modal-dialog"
        contentClassName="pur-modal-content border-0 bg-transparent"
      >
        {content}
      </Modal>
    );
  }

  return <div className="pur-page">{content}</div>;
};

export default ProfileUnderReview;